import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
  tableStyle: {
    border: "none",
    boxShadow: "none",
  },
  tableText: {
    fontFamily: "Open Sans",
    fontWeight: 'normal',
    fontSize: "12px",
    lineHeight: "16px",
    color: "#141414",
    textAlign: "center",
    margin: "10px",
    padding: "6px",
    minWidth: "120px"
  },
  tableHeader: {
    textAlign: "center",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    color: '#6F6F6F',
    fontSize: "14px",
    lineHeight: "19px",
    padding: "6px",
  },
  even: {
    background: "#F3F3F3",
  },
  odd: {
    background: "#FFFFFF",
  },
}));

function CNEPTable(props) {
  const classes = useStyles();
  useTheme();

  let counter = 0

  const getClass = (rowIndex) => {
    counter = counter + 1
    if (rowIndex % 2 === 0) {
      return classes.even;
    }

    return classes.odd;
  };

  return (
    <Paper className={classes.tableStyle}>
      <Table style={{ padding: "8px" }}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHeader}>Tipo de Sanção</TableCell>
            <TableCell className={classes.tableHeader}>Data de Publicação</TableCell>
            <TableCell className={classes.tableHeader}>Data Início</TableCell>
            <TableCell className={classes.tableHeader}>Data Fim</TableCell>
            <TableCell className={classes.tableHeader}>Órgão Sancionador</TableCell>
            <TableCell className={classes.tableHeader}>Valor</TableCell>
            <TableCell className={classes.tableHeader}>Detalhes</TableCell>
            <TableCell className={classes.tableHeader}>Base Legal</TableCell>
            <TableCell className={classes.tableHeader}>Descrição da Base Legal</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {props.cnep_data.map((item, index) => (
            <TableRow key={index} className={getClass(counter)}>
              <TableCell className={classes.tableText}>
                {item.sanction_type ?? "-"}
              </TableCell>
              <TableCell className={classes.tableText}>
                {item.publication_date ?? "-"}
              </TableCell>
              <TableCell className={classes.tableText}>
                {item.start_date ?? "-"}
              </TableCell>
              <TableCell className={classes.tableText}>
                {item.end_date ?? "-"}
              </TableCell>
              <TableCell className={classes.tableText}>
                {item.sanction_organ ?? "-"}
              </TableCell>
              <TableCell className={classes.tableText}>
                {item.value ?? "-"}
              </TableCell>
              <TableCell className={classes.tableText}>
                {item.details ?? "-"}
              </TableCell>
              <TableCell className={classes.tableText}>
                {item.legal_basis ?? "-"}
              </TableCell>
              <TableCell className={classes.tableText}>
                {item.legal_basis_description ?? "-"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

export default CNEPTable;
